import {
  SET_POS_TERMINAL,
  SET_POS_TERMINAL_LIST,
  SET_BLAZEPAY_PROCESSORS,
  SET_DEJAVOO_SHOP_CONFIG,
} from '../types/dejavoo'
import {
  getPosTerminalAPI,
  getBlazeConfigurationByShopAPI,
  getPosTerminalsAPI,
  addPosTerminalAPI,
  updatePosTerminalAPI,
  deletePosTerminalAPI,
  getBlazePayProcessorsAPI,
  checkOnlineAPI,
  getDejavooShopConfigAPI,
  updateDejavooShopConfigReceiptOptionAPI,
} from '../api/dejavoo'
import { addMessageCurry, commonActionAPIHit, getSession } from '../utils/api'

export const setPosTerminal = (payload) => ({
  type: SET_POS_TERMINAL,
  payload,
})

export const setPosTerminalList = (payload) => ({
  type: SET_POS_TERMINAL_LIST,
  payload: payload,
})

export const setBlazePayProcessors = (payload) => ({
  type: SET_BLAZEPAY_PROCESSORS,
  payload: payload,
})

export const setDejavooShopConfig = (payload) => ({
  type: SET_DEJAVOO_SHOP_CONFIG,
  payload: payload,
})

export const getPosTerminal = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getPosTerminalAPI(id), dispatch).then((res) => {
        dispatch(setPosTerminal(res))
        resolve(res)
      })
    })
  }
}

export const getPaymentsProcessor = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getBlazeConfigurationByShopAPI(), dispatch).then((res) => {
        var paymentsProcessor = res
        dispatch(setPosTerminalList({ paymentsProcessor }))
        resolve(paymentsProcessor)
      })
    })
  }
}

export const getPosTerminals = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getPosTerminalsAPI(), dispatch).then((res) => {
        var posTerminals = res.values
        dispatch(setPosTerminalList({ posTerminals }))
        resolve(posTerminals)
      })
    })
  }
}

export const getBlazePayProcessors = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getBlazePayProcessorsAPI(), dispatch).then((res) => {
        var processors = res
        dispatch(setPosTerminalList({ processors }))
        resolve(processors)
      })
    })
  }
}

export const addPosTerminal = (terminal) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(addPosTerminalAPI(terminal), dispatch).then((terminal) => {
        resolve(terminal)
      })
    })
  }
}

export const updatePosTerminal = (terminal) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updatePosTerminalAPI(terminal), dispatch).then((terminal) => {
        resolve(terminal)
      })
    })
  }
}

export const deletePosTerminal = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(deletePosTerminalAPI(id), dispatch).then((terminal) => {
        resolve(terminal)
      })
    })
  }
}

export const checkOnline = (terminalId, registerId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(checkOnlineAPI(terminalId, registerId), dispatch).then((res) => {
        resolve(res)
      })
    })
  }
}

export const getDejavooShopConfig = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getDejavooShopConfigAPI(), dispatch).then((res) => {
        var dejavooShopConfig = res
        dispatch(setDejavooShopConfig({ dejavooShopConfig }))
        resolve(dejavooShopConfig)
      })
    })
  }
}

export const updateDejavooShopConfigReceiptOption = (printReceiptOption) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateDejavooShopConfigReceiptOptionAPI(printReceiptOption), dispatch).then(
        (dejavooShopConfig) => {
          resolve(dejavooShopConfig)
        },
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/dejavoo.js